import {UIProfileSettingsController} from '../../../../../../shared/scripts/profile/UIProfileSettingsController.ts'
import {UIMDeviceInfoPopup} from '../../../../ui_popup/UIMDeviceInfoPopup.ts'
import {ViewPopupEditProfile} from '../../../../../../shared/scripts/ui_popup/ViewPopupEditProfile.ts'
import {UIMProfileUsernameController} from '../UIMProfileUsernameController.ts'
import {type PlayerColor} from '@colonist/game-states'
import {ProfileEditAjaxEndPoints} from '../../../../../../shared/scripts/profile/ProfileEditAjaxEndPoints.ts'
import {setElementOnClick} from '../../../../../../shared/scripts/ui_utils/DomUtils.ts'

export class UIMProfileSettingsController extends UIProfileSettingsController {
    private readonly editProfileButton: HTMLButtonElement

    constructor() {
        super()
        this.editProfileButton = document.getElementById('m-edit-profile') as HTMLButtonElement
        setElementOnClick(this.editProfileButton, () => {
            new ViewPopupEditProfile({
                usernameController: UIMProfileUsernameController,
                selectColorAction: async(color: PlayerColor) => await ProfileEditAjaxEndPoints.updatePreferredColor(color),
            })
        })

        const deviceInfoButton = document.getElementById('m-debug-info') as HTMLButtonElement
        setElementOnClick(deviceInfoButton, () => new UIMDeviceInfoPopup().show())
    }
}
